// extracted by mini-css-extract-plugin
export default {"audioplayer":"audioplayer_audioplayer__nEANw","progress-text":"audioplayer_progress-text__Xejs9","timing":"audioplayer_timing__OgWmg"};